module Meevo.Components.Modal {
  angular.module("meevo.components.modal", []);
}